import type { LoomAuthoringDocument } from "./loomAuthoringModel";

export function LoomActivePartHud({
  document,
  outlineCount,
  selectedNodeId,
}: {
  document: LoomAuthoringDocument;
  outlineCount: number;
  selectedNodeId: string;
}) {
  const node = document.nodes.find((candidate) => candidate.id === selectedNodeId);
  if (!node) return null;
  const derived = node.type === "transform" && node.operation.transform === "mirror";
  const sourceNodeId = derived ? node.inputNodeId : node.id;
  return (
    <>
      <div
        className="loom-active-part"
        data-entity-kind={derived ? "derived" : "authored"}
        data-node-id={node.id}
        data-outline-count={outlineCount}
        data-source-node-id={sourceNodeId}
        data-testid="loom-active-part"
      >
        <span>Active part</span><strong>{node.label}</strong>
        <small>{derived ? `Derived mirror of ${sourceNodeId}` : `${node.type} · ${node.id}`}</small>
      </div>
      {outlineCount > 0 ? <span data-node-id={node.id} data-testid="loom-active-outline" hidden>{outlineCount}</span> : null}
    </>
  );
}
